export default __webpack_public_path__ + "static/media/thumbDownIcon.e6528382.svg";